import './ButtonTypeSolidIcon.scss';